import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { rootReducer } from './app/Reducers/index';
import { configureStore } from './app/Store/configurestore';

const store = configureStore();

import { routes } from './app/routes';

function renderApp() {
    ReactDOM.render(
        <Provider store={store} >
            <BrowserRouter children={routes} />
        </Provider>,
            document.getElementById('react-app'));
}

renderApp();



// WEBPACK FOOTER //
// ./ClientApp/boot.tsx